import { AlignCenter } from "style/layout";
import styled from "styled-components";

export const ImgWrapper = styled(AlignCenter)`
  padding-top: 10vh;
`;
